import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { X, Download } from "lucide-react";
import { toast } from "sonner";
import { NeuButton } from "../../components/neu/Neu";
import { fetchFileBlob } from "../../api/acctExport";

// One-click receipt preview (image or PDF) for bills, journal entries and expenses.
export const ReceiptViewer = ({ url, onClose }) => {
  const { t } = useTranslation();
  const [blob, setBlob] = useState("");
  const isPdf = /\.pdf($|\?)/i.test(url || "");

  useEffect(() => {
    let current = "";
    let cancelled = false;
    fetchFileBlob(url)
      .then((objectUrl) => {
        current = objectUrl;
        if (cancelled) URL.revokeObjectURL(objectUrl);
        else setBlob(objectUrl);
      })
      .catch(() => toast.error(t("acct.receiptLoadFailed")));
    return () => {
      cancelled = true;
      if (current) URL.revokeObjectURL(current);
    };
  }, [url, t]);

  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm"
      data-testid="receipt-viewer"
      onClick={onClose}
    >
      <div
        className="flex max-h-[90vh] w-full max-w-2xl flex-col gap-3 rounded-3xl bg-background p-4 shadow-neu-sm"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between gap-3">
          <p className="text-sm font-bold">{t("acct.receiptViewer")}</p>
          <div className="flex items-center gap-2">
            {blob ? (
              <a href={blob} download data-testid="receipt-download">
                <NeuButton className="px-3 py-2 text-xs">
                  <Download className="h-3.5 w-3.5" />
                </NeuButton>
              </a>
            ) : null}
            <NeuButton className="px-3 py-2 text-xs" data-testid="receipt-close" onClick={onClose}>
              <X className="h-3.5 w-3.5" />
            </NeuButton>
          </div>
        </div>
        <div className="min-h-[240px] flex-1 overflow-auto rounded-2xl shadow-neu-in">
          {!blob ? (
            <p className="p-6 text-center text-xs text-muted-foreground">{t("acct.uploading")}</p>
          ) : isPdf ? (
            <iframe src={blob} title="receipt" className="h-[70vh] w-full rounded-2xl" />
          ) : (
            <img src={blob} alt="receipt" className="mx-auto max-h-[70vh] rounded-2xl object-contain" />
          )}
        </div>
      </div>
    </div>
  );
};
